module.exports = __webpack_public_path__ + "static/media/sterilizing.7af19d9c.png";